import React, { useState } from 'react';

const CurrentLocation = ({ onAddressRetrieved }) => {
  const [loading, setLoading] = useState(false);

  const getCurrentLocation = () => {
    setLoading(true);

    if (!navigator.geolocation) {
      onAddressRetrieved("Geolocation is not supported by this browser", null);
      setLoading(false);
      return;
    }

    navigator.geolocation.getCurrentPosition(
      async ({ coords }) => {
        const { latitude, longitude } = coords;
        const apiKey = process.env.REACT_APP_GEOCODING_GOOGLE_MAPS_API_KEY;

        try {
          const response = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${apiKey}`
          );
          const data = await response.json();

          if (data.status !== 'OK' || !data.results.length) {
            throw new Error(`Google API error: ${data.status}`);
          }

          const result = data.results[0];
          const addressComponents = result.address_components || [];

          const getComponent = (types) =>
            addressComponents.find((comp) =>
              types.every((type) => comp.types.includes(type))
            )?.long_name || '';

          const placeName =
            getComponent(['locality']) ||
            getComponent(['administrative_area_level_2']) ||
            getComponent(['administrative_area_level_1']);

          const landmark =
            getComponent(['neighborhood']) ||
            getComponent(['sublocality']) ||
            getComponent(['route']);

          const pin = getComponent(['postal_code']);
          const state = getComponent(['administrative_area_level_1']);
          const country = getComponent(['country']);

          const customAddress = [
            placeName,
            landmark ? `near ${landmark}` : '',
            pin,
            state,
            country
          ]
            .filter(Boolean)
            .join(', ');

          const finalAddress = customAddress || result.formatted_address || 'Address unavailable';

          console.log("Final Address:", finalAddress);
          onAddressRetrieved(finalAddress, { lat: latitude, lng: longitude });
        } catch (error) {
          console.error("Geocoding error:", error);
          onAddressRetrieved("Current location (address not available)", { lat: latitude, lng: longitude });
        } finally {
          setLoading(false);
        }
      },
      (error) => {
        console.error("Geolocation error:", error);
        onAddressRetrieved("Unable to get current location", null);
        setLoading(false);
      },
      {
        enableHighAccuracy: true,
        timeout: 15000,
        maximumAge: 0,
      }
    );
  };

  return (
    <div>
      <button className="location-btn yellow" onClick={getCurrentLocation} disabled={loading}>
        {loading ? "Getting Location..." : "Get Current Location"}
      </button>
    </div>
  );
};

export default CurrentLocation;
